module.exports = __webpack_public_path__ + "static/media/EVEREVE-TrensendStackedLogoWhite.cb3724d2.png";